import { Injectable } from '@angular/core';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { createSelector, select, Store } from '@ngrx/store';
import { OrderedSet } from 'immutable';
import { Observable } from 'rxjs';

import { featureSelector, IAppRootState } from './feature.store';
import { TagSliceKey, TagSliceState } from './tag.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[TagSliceKey]
);

const tagsSelector = createSelector(baseSelector, (state) =>
	state.get('availableTags')
);

@Injectable({
	providedIn: 'root',
})
export class TagSelector {
	public constructor(private readonly store: Store<IAppRootState>) {}

	private get state(): Observable<TagSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getTags$(): Observable<OrderedSet<AppTagItemEntity>> {
		return this.store.pipe(select(tagsSelector));
	}
}
